// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__28XaR","content":"styles_content__3gnP2","selectAll":"styles_selectAll__jB2wM"};